import type { Blob2DInPatchUnits } from './Blob2DInPatchUnits';

function iou(a: Blob2DInPatchUnits, b: Blob2DInPatchUnits): number {
  const ax2 = a.x + a.width;
  const ay2 = a.y + a.height;
  const bx2 = b.x + b.width;
  const by2 = b.y + b.height;

  const ix1 = Math.max(a.x, b.x);
  const iy1 = Math.max(a.y, b.y);
  const ix2 = Math.min(ax2, bx2);
  const iy2 = Math.min(ay2, by2);

  const iw = ix2 - ix1;
  const ih = iy2 - iy1;
  if (iw <= 0 || ih <= 0) return 0;

  const inter = iw * ih;
  const union = a.width * a.height + b.width * b.height - inter;

  return inter / union;
}

// Standard greedy NMS. Sort by score desc; keep highest-scoring blob, drop
// any not-yet-kept blob whose IoU with a kept blob exceeds the threshold.
export function nonMaxSuppression(
  blobs: ReadonlyArray<Blob2DInPatchUnits>,
  iouThreshold: number,
): Blob2DInPatchUnits[] {
  if (blobs.length === 0) return [];
  const sorted = [...blobs].sort((a, b) => b.score - a.score);
  const kept: Blob2DInPatchUnits[] = [];

  for (const candidate of sorted) {
    let suppressed = false;

    for (const k of kept) {
      if (iou(candidate, k) > iouThreshold) {
        suppressed = true;
        break;
      }
    }

    if (!suppressed) {
      kept.push(candidate);
    }
  }

  return kept;
}
